<div class="duplicate-customers">
  <nz-card>
    <div class="header">
      <div>
        <h2>განმეორებადი ნომრები</h2>
        <p class="subtitle">
          კლიენტები, რომლებსაც ერთი და იგივე ტელეფონის ნომერი უწერიათ.
        </p>
      </div>

      <div class="actions">
        <!-- ONE box for both meanings. The operator has either the number the
             customer gave or the name on the record, and should not have to
             know which field the server files it under. -->
        <!-- The suffix template is always supplied and the icon inside it is
             conditional. `nzSuffix` is typed `string | TemplateRef<void>`, so
             a `null` from a ternary does not compile -- caught by
             `nx build beauty`, which is the only command that type-checks a
             template. -->
        <nz-input-group
          class="search"
          [nzPrefix]="searchIcon"
          [nzSuffix]="clearIcon"
        >
          <input
            nz-input
            type="text"
            placeholder="ნომერი ან სახელი"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange()"
            (keyup.enter)="runSearch()"
          />
        </nz-input-group>

        <ng-template #searchIcon>
          <span nz-icon nzType="search"></span>
        </ng-template>
        <ng-template #clearIcon>
          <span
            *ngIf="search"
            nz-icon
            nzType="close-circle"
            class="clear"
            (click)="clearSearch()"
          ></span>
        </ng-template>

        <button nz-button nzType="default" (click)="load()" [disabled]="loading">
          <span nz-icon nzType="reload"></span>
          განახლება
        </button>
      </div>
    </div>

    <!-- A candidate list, not a verdict. Said once, at the top, so nobody
         reads the table as "these are duplicates, delete them".

         The first sentence CHANGES with the flag. "This list only shows" was
         true in slice 1 and became a plain lie the moment merging was switched
         on -- on the one screen in the app where an irreversible action lives.
         Found by opening the page after the merge worked. -->
    <nz-alert
      [nzType]="mergeEnabled ? 'warning' : 'info'"
      nzShowIcon
      [nzMessage]="
        mergeEnabled
          ? 'შერწყმა შეუქცევადია — შერწყმული ჩანაწერი აღარ დაბრუნდება.'
          : 'ეს სია მხოლოდ აჩვენებს — არაფერს შლის და არაფერს აერთიანებს.'
      "
      nzDescription="ერთი ნომერი ყოველთვის არ ნიშნავს ორ ერთსა და იმავე ადამიანს: დედა და შვილი ერთ ნომერს ხშირად იზიარებენ. გახსენით ჩანაწერები და თავად შეადარეთ."
    ></nz-alert>

    <nz-alert
      *ngIf="loadError"
      class="load-error"
      nzType="error"
      nzShowIcon
      nzMessage="სია ვერ ჩაიტვირთა"
      nzDescription="ცარიელი ცხრილი ამ შემთხვევაში არ ნიშნავს, რომ დუბლიკატები არ არის. სცადეთ განახლება."
    ></nz-alert>

    <div class="summary" *ngIf="!loadError && !loading">
      <ng-container *ngIf="!searched">
        ნაპოვნია <strong>{{ total }}</strong> ნომერი, რომელზეც ერთზე მეტი
        კლიენტი ზის.
      </ng-container>
      <!-- Says it is a FILTERED count. Otherwise "ნაპოვნია 2" after a search
           reads as "this organisation has 2 duplicates", when it has 77. -->
      <ng-container *ngIf="searched">
        ძებნის შედეგი: <strong>{{ total }}</strong> ნომერი.
      </ng-container>
      <span *ngIf="groups.length">
        ამ გვერდზე — {{ groups.length }} ნომერი, {{ customersOnPage }} ჩანაწერი.
      </span>
    </div>

    <nz-table
      #table
      [nzData]="groups"
      [nzLoading]="loading"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [nzPageIndex]="page"
      [nzPageSize]="pageSize"
      (nzPageIndexChange)="onPageChange($event)"
      nzSize="small"
    >
      <thead>
        <tr>
          <th nzWidth="50px"></th>
          <th>ნომერი</th>
          <th nzWidth="180px">ჩანაწერების რაოდენობა</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let group of table.data; trackBy: trackGroup">
          <tr>
            <td
              [nzExpand]="expanded.has(group.phone)"
              (nzExpandChange)="toggle(group.phone, $event)"
            ></td>
            <td class="phone">{{ group.phone }}</td>
            <td>
              <nz-tag [nzColor]="group.total > 2 ? 'red' : 'orange'">
                {{ group.total }}
              </nz-tag>
            </td>
          </tr>

          <!-- DIVS, NOT A NESTED TABLE. `nz-table` projects any `<thead>` it
               finds anywhere beneath it into its OWN header, not just a direct
               child -- so a members table with a `<thead>` loses it, and the
               outer table displays the members' column names above the group
               rows. Measured in the browser: `innerHasThead: false`.

               Neither the unit tests nor `nx build` catch it; both read the
               Angular template rather than what ng-zorro finally renders. Same
               div shape sms-templates uses inside its expand row. -->
          <!-- NO `<td>` here. `nzExpand` supplies its own `td.nz-disable-td`
               with the right colspan; adding one nests a `td` inside a `td`,
               which is invalid, and the block shrank from 1528px to 999px. -->
          <tr [nzExpand]="expanded.has(group.phone)">
              <div class="members" role="table">
                <div
                  class="members-row members-head"
                  role="row"
                  [class.with-merge]="mergeEnabled"
                >
                  <span *ngIf="mergeEnabled" role="columnheader">რჩება</span>
                  <span *ngIf="mergeEnabled" role="columnheader">ერწყმის</span>
                  <span role="columnheader">სახელი და გვარი</span>
                  <span role="columnheader">ნომერი (როგორც ჩაწერეს)</span>
                  <span role="columnheader">პირადი ნომერი</span>
                  <span role="columnheader">ბარათი</span>
                  <span role="columnheader">დარეგისტრირდა</span>
                  <!-- beaut-563. Renamed, not restyled: the cell below has always
                       rendered BOTH the balance and the debt, so "ბალანსი" was
                       under-describing its own contents and an operator reading
                       a debt figure had no way to know which one it was. -->
                  <span role="columnheader">ბალანსი/დავალიანება</span>
                  <span role="columnheader">ბოლო ვიზიტი</span>
                  <span role="columnheader">ვიზიტები</span>
                  <span role="columnheader">აქტ. პაკეტები</span>
                  <span role="columnheader"></span>
                </div>

                <div
                  class="members-row"
                  role="row"
                  [class.with-merge]="mergeEnabled"
                  *ngFor="let customer of group.customers; trackBy: trackCustomer"
                >
                  <!-- Radio = survives, checkbox = folded in. A record cannot be
                       both; picking one clears the other, because the server
                       refuses that combination and the screen should never
                       build it. -->
                  <span *ngIf="mergeEnabled" role="cell">
                    <label
                      nz-radio
                      [ngModel]="keepId[group.phone] === customer.id"
                      (ngModelChange)="chooseKeep(group, customer.id)"
                      [ngModelOptions]="{ standalone: true }"
                    ></label>
                  </span>
                  <span *ngIf="mergeEnabled" role="cell">
                    <label
                      nz-checkbox
                      [ngModel]="isSelected(group, customer.id)"
                      (ngModelChange)="toggleSelected(group, customer.id, $event)"
                      [ngModelOptions]="{ standalone: true }"
                    ></label>
                  </span>
                  <span role="cell">{{ displayName(customer) }}</span>
                  <!-- As typed, not normalised: the difference in spelling is
                       often the only clue which record was entered by hand. -->
                  <span role="cell">{{ customer.mobilePhone || '—' }}</span>
                  <span role="cell">{{ customer.identityNumber || '—' }}</span>
                  <span role="cell">{{ customer.cardNo || '—' }}</span>
                  <span role="cell">{{
                    customer.createdAt | date: 'dd/MM/yyyy HH:mm'
                  }}</span>
                  <span role="cell" class="money">
                    <ng-container *ngIf="customer.balance">{{
                      customer.balance | number: '1.0-2'
                    }}₾</ng-container>
                    <ng-container *ngIf="customer.debt">
                      <!-- beaut-563. `debt` is stored with EITHER sign -- 42 rows
                           negative and 8 positive on stage -- while this printed a
                           hardcoded minus in front of it. The majority case came
                           out as "--245₾", and a customer holding both read
                           "320₾--380₾", which is exactly the confusion renaming
                           this column was meant to end. One minus, magnitude
                           after, whichever way the row happens to be stored. -->
                      <span class="debt"
                        >-{{
                          (customer.debt < 0 ? -customer.debt : customer.debt)
                            | number: '1.0-2'
                        }}₾</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!customer.balance && !customer.debt">—</ng-container>
                  </span>
                  <!-- beaut-563. What the record has actually been used for.
                       `lastVisit` arrives as a plain "YYYY-MM-DD" string
                       precisely so it is not shifted by an offset on the way
                       here; Angular's DatePipe parses a date-only ISO string as
                       LOCAL, so it stays the date the database holds. -->
                  <span role="cell">{{
                    customer.lastVisit ? (customer.lastVisit | date: 'dd/MM/yyyy') : '—'
                  }}</span>
                  <!-- Zero is shown, not blanked. An empty cell beside a real
                       number reads as "not loaded" rather than "never". -->
                  <span role="cell">{{ customer.visitCount }}</span>
                  <span role="cell">{{ customer.activePackages?.length || 0 }}</span>
                  <span role="cell">
                    <button
                      nz-button
                      nzType="link"
                      nzSize="small"
                      (click)="openCustomer(customer)"
                    >
                      გახსნა
                    </button>
                  </span>
                </div>

                <div class="members-actions" *ngIf="mergeEnabled">
                  <span class="hint" *ngIf="!canMerge(group)">
                    აირჩიეთ ერთი ჩანაწერი, რომელიც რჩება, და მონიშნეთ ის, რაც მას
                    უნდა შეერწყას.
                  </span>
                  <button
                    nz-button
                    nzType="primary"
                    nzDanger
                    nzSize="small"
                    [disabled]="!canMerge(group)"
                    (click)="openConfirm(group)"
                  >
                    შერწყმა
                  </button>
                </div>
              </div>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>

    <!-- Two different empties. "Nothing found" after a search means the search
         found nothing; without one it means this organisation is clean. Saying
         the same sentence for both would let a typo look like good news. -->
    <!-- The result of the last merge. Says how many rows actually moved rather
         than "done": "the merge ran" is not a fact anybody can check. -->
    <nz-alert
      *ngIf="mergeResult"
      class="merge-result"
      nzType="success"
      nzShowIcon
      nzCloseable
      (nzOnClose)="mergeResult = null"
      [nzMessage]="
        'შერწყმულია ' +
        mergeResult.merged +
        ' ჩანაწერი. გადატანილია ' +
        mergeResult.moved +
        ' ჩანაწერი სხვა ცხრილებში.'
      "
    ></nz-alert>

    <nz-empty
      *ngIf="!loading && !loadError && !groups.length"
      [nzNotFoundContent]="
        searched
          ? 'ამ ძებნაზე არაფერი მოიძებნა.'
          : 'განმეორებადი ნომერი არ მოიძებნა.'
      "
    ></nz-empty>
  </nz-card>

  <!-- The confirmation. It names the records by name rather than counting
       them: "2 records will be deleted" is not something an operator can check
       against what they meant. -->
  <nz-modal
    [nzVisible]="!!confirming"
    nzTitle="ჩანაწერების შერწყმა"
    nzWidth="680px"
    [nzOkText]="'დიახ შენახვა'"
    [nzCancelText]="'გაუქმება'"
    [nzOkLoading]="merging"
    [nzOkDanger]="true"
    (nzOnCancel)="cancelConfirm()"
    (nzOnOk)="confirmMerge()"
  >
    <ng-container *nzModalContent>
      <ng-container *ngIf="confirming as group">
        <nz-alert
          nzType="warning"
          nzShowIcon
          nzMessage="ეს მოქმედება შეუქცევადია."
          nzDescription="ეს მოქმედება ცვლის მომხმარებელთან დაკავშირებულ ისტორიულ კავშირებს. შერწყმის შემდეგ სისტემა ვეღარ იტყვის, რომელი ვიზიტი რომელ ჩანაწერს ეკუთვნოდა."
        ></nz-alert>

        <div class="confirm-block">
          <div class="confirm-label">რჩება</div>
          <div class="confirm-keep">
            {{ displayName(keptRecord(group)!) }}
            <span class="muted">
              · {{ keptRecord(group)!.mobilePhone || '—' }}
              · რეგისტრაცია {{ keptRecord(group)!.createdAt | date: 'dd/MM/yyyy' }}
            </span>
          </div>
        </div>

        <div class="confirm-block">
          <div class="confirm-label">
            იშლება ({{ mergedRecords(group).length }})
          </div>
          <div class="confirm-merged" *ngFor="let c of mergedRecords(group)">
            {{ displayName(c) }}
            <span class="muted">
              · {{ c.mobilePhone || '—' }}
              · რეგისტრაცია {{ c.createdAt | date: 'dd/MM/yyyy' }}
            </span>
            <!-- beaut-564. A name and a date do not say whether this record is
                 an empty duplicate or the one holding forty visits and a live
                 package. Always shown, zero included: a blank would read as
                 "not loaded" rather than "none". -->
            <span class="confirm-carries">
              {{ c.visitCount }} ვიზიტი
              <ng-container *ngIf="c.activePackages?.length">
                ·
                <span class="confirm-packages">
                  {{ c.activePackages.length }} აქტიური პაკეტი:
                  {{ c.activePackages.join(', ') }}
                </span>
              </ng-container>
            </span>
          </div>
        </div>

        <!-- Shown only when it is a real choice. Asking about money that does
             not exist trains the operator to click past the question. -->
        <ng-container *ngIf="needsMoneyChoice(group)">
          <nz-divider></nz-divider>
          <div class="confirm-label">
            ერთზე მეტ ჩანაწერს უდევს თანხა — რა ვქნათ?
          </div>

          <div class="money-list">
            <div *ngFor="let c of moneyHolders(group)" class="money-line">
              <!-- beaut-564. The record that SURVIVES is in this list, and QA
                   read it as one of the records being deleted. It is not
                   removed: its amount is part of the answer either way — SUM
                   adds it, KEEP can select it — and the server counts it when
                   deciding whether to demand a choice at all. Dropping it from
                   the list would make the question unanswerable for the case
                   where only the survivor and one duplicate hold money: the
                   screen would stop asking and the server would refuse the
                   merge. So it is named instead of hidden. -->
              <span class="stays-tag" *ngIf="c.id === keepId[group.phone]">რჩება</span>
              {{ displayName(c) }}:
              <strong>{{ c.balance | number: '1.0-2' }}₾</strong> ბალანსი
              <ng-container *ngIf="c.debt">
                · <strong class="debt">{{ c.debt | number: '1.0-2' }}₾</strong> ვალი
              </ng-container>
              <ng-container *ngIf="c.minutes">
                · <strong>{{ c.minutes }}</strong> წუთი
              </ng-container>
            </div>
          </div>

          <nz-radio-group
            [(ngModel)]="moneyMode"
            [ngModelOptions]="{ standalone: true }"
            class="money-modes"
          >
            <label nz-radio nzValue="SUM">დაჯამდეს</label>
            <label nz-radio nzValue="KEEP">შენარჩუნდეს ერთის თანხა</label>
          </nz-radio-group>

          <nz-radio-group
            *ngIf="moneyMode === 'KEEP'"
            [(ngModel)]="moneySourceId"
            [ngModelOptions]="{ standalone: true }"
            class="money-source"
          >
            <label nz-radio [nzValue]="c.id" *ngFor="let c of moneyHolders(group)">
              {{ displayName(c) }} ({{ c.balance | number: '1.0-2' }}₾)
            </label>
          </nz-radio-group>
        </ng-container>

        <nz-alert
          *ngIf="mergeError"
          class="merge-error"
          nzType="error"
          nzShowIcon
          [nzMessage]="mergeError"
        ></nz-alert>
      </ng-container>
    </ng-container>
  </nz-modal>
</div>
